import {observer} from 'mobx-react';
import * as React from 'react';
import {Component} from 'react';
import {autobind} from "core-decorators";
import {observable} from "mobx";
import {RecordRTCPromisesHandler, StereoAudioRecorder} from 'recordrtc';
import {config} from "config";
import {graphql} from "../../configs/graphql.client";
import {
    OptimizedAudioAvailableDocument,
    OptimizedAudioAvailableQuery,
    OptimizedAudioAvailableQueryVariables
} from "../../types.d";

interface AudioRecorderProps {
    value?: string;
    onChange;
    onStartRecording?;
    waitOptimized?: boolean;
    static?: boolean;
}

@observer export class AudioRecorder extends Component<AudioRecorderProps, any> {

    audioStream: MediaStream;
    recorder: RecordRTCPromisesHandler;
    audioElm: HTMLAudioElement;

    @observable isOptimizedCreated = false;
    @observable isCountdownActive = false;
    @observable isRecording = false;
    @observable countdown = 3;
    @observable audioPreview;
    @observable audio;
    @observable value;

    countdownInterval;

    constructor(props) {
        super(props);

        if (props.value) {
            this.audioPreview = props.value;
            this.audio = props.value;

            this.replaceWithOptimized();
        }
    }

    async replaceWithOptimized() {
        if (this.props.value) {
            /*const optimized = this.props.value + '.mp3';

            fetch(optimized, {
                method: 'HEAD'
            }).then(result => {
                if (result.status === 200) {
                    this.audioPreview = optimized;
                    this.audio = optimized;
                }
            })*/

            const result = await graphql.client.query<OptimizedAudioAvailableQuery, OptimizedAudioAvailableQueryVariables>({
                query: OptimizedAudioAvailableDocument,
                variables: {
                    fileUrl: this.props.value,
                    id: 1,
                    noTimeout: true
                }
            });

            if (result.data.optimizedAudioAvailable.url) {
                this.audioPreview = result.data.optimizedAudioAvailable.url;
                this.audio = result.data.optimizedAudioAvailable.url;
            }
        }
    }

    @autobind async startRecording() {
        this.recorder.startRecording();

        if (this.props.onStartRecording) {
            this.props.onStartRecording();
        }

        this.isRecording = true;
    }

    @autobind async stopRecording() {
        await this.recorder.stopRecording();
        const blob = await this.recorder.getBlob();
        this.audioPreview = URL.createObjectURL(blob);

        const data = new FormData();

        const reader = new window.FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = async () => {
            if (!this.props.static) {
                const base64data = reader.result;
                data.append('wav_encoded', base64data as string);

                const result = await fetch(config.backendBase + '/uploader', {
                    method: 'POST',
                    headers: {},
                    body: data,
                });

                const json = await result.json();
                this.audio = json.filepath;
                this.audioPreview = this.audio;

                this.props.onChange(json.filepath);

                this.waitOptimized(json.filepath, json.id);
            } else {
                this.audio = 'file_path.wav';
                this.audioPreview = this.audio;
                this.props.onChange(this.audio);
            }

            this.isRecording = false;
        };
    }

    async waitOptimized(filepath, id) {
        if (this.props.waitOptimized) {
            const result = await graphql.client.query<OptimizedAudioAvailableQuery, OptimizedAudioAvailableQueryVariables>({
                query: OptimizedAudioAvailableDocument,
                variables: {
                    fileUrl: filepath,
                    id
                }
            });

            if (result.data.optimizedAudioAvailable.url) {
                this.isOptimizedCreated = true;
                this.audioPreview = result.data.optimizedAudioAvailable.url;
                this.audio = result.data.optimizedAudioAvailable.url;
            }
        }
    }

    @autobind async startCountdown() {
        this.audioStream = await navigator.mediaDevices.getUserMedia({video: false, audio: true});
        this.recorder = new RecordRTCPromisesHandler(this.audioStream, {
            type: 'audio',
            mimeType: 'audio/wav',
            recorderType: StereoAudioRecorder,
        });

        this.isCountdownActive = true;

        this.countdownInterval = setInterval(() => {
            if (this.countdown < 2) {
                clearInterval(this.countdownInterval);
                this.countdown = 3;

                this.isCountdownActive = false;
                this.startRecording();
            } else {
                this.countdown -= 1;
            }
        }, 1000);
    }

    @autobind handleButton() {
        if (this.isRecording) {
            this.stopRecording();
        }

        if (!this.isRecording && !this.isCountdownActive) {
            this.startCountdown();
        }
    }

    @autobind play() {
        this.audioElm.play();
    }

    _renderIcon() {
        let buttonClasses = '';

        if (this.isCountdownActive) {
            buttonClasses = `countdown-${this.countdown}`;
        }

        if (this.isRecording) {
            buttonClasses = `in-progress`;
        }

        return <>
            <button
                className={`record-button ${buttonClasses}`}
                onClick={this.handleButton}
                data-mode="start"
                type="button">Record</button>
            { this.audioPreview && <button className="record-play-button" type="button" onClick={this.play}>Play</button> }
            { this.audio && <button className="record-save-button saved" type="button" disabled={true}>Save</button> }
            { this.isOptimizedCreated && <button className="record-save-button saved" type="button" disabled={true}>Save</button> }
        </>
    }

    render() {
        return <div>
            { this._renderIcon() }

            { this.audio && <audio src={this.audio} ref={elm => this.audioElm = elm} controls={false} /> }
        </div>
    }

}
